<ng-container>
  <header app-header></header>

  <main class="container content" id="app-content" tabindex="-1">
    <ngf-feedback id="service-message"></ngf-feedback>
    <router-outlet></router-outlet>
  </main>
</ng-container>
